<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <!-- <el-form-item label="序号" prop="title" label-width="40px">
            <el-input class="form-input" v-model="searchForm.title" size="small" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="类型编码" prop="typeCode">
            <el-input class="form-input" v-model="searchForm.typeCode" clearable></el-input>
          </el-form-item>
           <el-form-item label="类型名称" prop="typeName">
            <el-input class="form-input" v-model="searchForm.typeName" clearable></el-input>
          </el-form-item>
          <el-form-item label="更新人" prop="updatedBy">
            <el-input class="form-input" v-model="searchForm.updatedBy" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="编辑时间" prop="updatedTime">
            <el-date-picker
              class="date-input"
              size="small"
              v-model="searchForm.updatedTime"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item> -->
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        border
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="sortNo" label="排序号" align="center" width="80"></el-table-column>
        <el-table-column prop="typeCode" label="类型编码"></el-table-column>
        <el-table-column prop="typeName" label="类型名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="describe" label="类型描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updatedBy" label="更新人" align="center" width="120"></el-table-column>
        <el-table-column prop="updatedTime" label="更新时间" align="center"  width="160">
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column  label="操作"  class-name="action-column" align="center"  width="150">
          <template v-slot="scope">
            <el-button  type="text" size="small" @click="jumpDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <newAddField 
      :isNewAddPopup.sync="isNewAddPopup"
      v-if="isNewAddPopup"
      :formItems="dictionariesFormItems"
      :editData.sync='editData'
      @onConfirm="onConfirm"
      InputWidth="100%"
      :title="editData.operationType == 'add' ? '新增':'编辑'"
      />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import newAddField from '../add-dialog'
import { dictionariesFormItems } from '../config'
export default {
  name: "dataField",
  mixins: [tableMixin,pagePathMixin],
  components: {
    newAddField
  },
  data() {
    return {
      searchForm: {
        typeCode: '',
        typeName: '',
        updatedBy: '',
      },

      // 表格相关
      dictionariesFormItems,
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,

      isNewAddPopup: false,
      editData: {
        sortNo: '',
        typeCode: '',
        typeName: '',
        describe: ''
      }
    }
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.configure.queryDiceList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        title: '',
        status: '',
        createUser: '',
        createDate: []
      };
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === 'updatedTime' && val) {
          this.filterParam.updatedTimeStart = val[0] || '';
          this.filterParam.updatedTimeEnd = val[1] || '';
        } else if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    jumpDetail(row) {
      this.openSubPage({
        path: '/configure/dictionaries',
        query: {typeCode: row.typeCode}
      })
    },
    onConfirm() {
      this.$api.configure.saveOrUpdateDict(this.editData)
        .then(res => {
          if (res.success) {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.isNewAddPopup = false
            this.init()
            this.editData ={}
          }
        })
    },
    handleAdd() {
      this.editData = {
        sortNo: '',
        typeCode: '',
        typeName: '',
        describe: '',
        operationType: 'add'
      }
      this.dictionariesFormItems[1].inputConf.disabled = false
      this.isNewAddPopup = true
    },
    handleEdit(row) {
      this.editData = {...row}
      this.editData.operationType = 'update'
      this.dictionariesFormItems[1].inputConf.disabled = true
      this.isNewAddPopup = true
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>